(() => {
  'use strict';

  const configNode = document.querySelector('[data-alfa-noodpakket-discount-config]');
  if (!configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    console.error('[Alfa noodpakket discount] Ongeldige configuratie.', error);
    return;
  }

  const routeRoot = window.Shopify?.routes?.root || '/';
  const normalizedRouteRoot = routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`;
  const cartUrl = `${normalizedRouteRoot}cart.js`;
  const cartUpdateUrl = `${normalizedRouteRoot}cart/update.js`;
  const checkoutUrl = `${normalizedRouteRoot}checkout`;
  const codesByPercentage = config.codes_by_percentage || {};
  const tiers = (Array.isArray(config.tiers) ? config.tiers : [])
    .map((tier) => ({
      min: Number(tier.min_unique_products || 0),
      percentage: Number(tier.percentage || 0),
    }))
    .filter((tier) => tier.min > 0 && tier.percentage > 0 && codesByPercentage[String(tier.percentage)])
    .sort((a, b) => a.min - b.min);
  const bundleCodes = new Set(Object.values(codesByPercentage).map((code) => String(code).toUpperCase()));
  let checkoutBusy = false;

  const discountApplications = (cart) => {
    const applications = Array.isArray(cart?.cart_level_discount_applications)
      ? [...cart.cart_level_discount_applications]
      : [];

    (Array.isArray(cart?.items) ? cart.items : []).forEach((item) => {
      (Array.isArray(item?.line_level_discount_allocations) ? item.line_level_discount_allocations : [])
        .forEach((allocation) => {
          if (allocation?.discount_application) applications.push(allocation.discount_application);
        });
    });

    return applications;
  };

  const eligibleUniqueCount = (cart) => {
    const eligibleProperty = String(config.eligible_property || '_BundleEligible');
    const eligibleValue = String(config.eligible_value || 'yes').toLowerCase();
    const productIds = new Set();

    (Array.isArray(cart?.items) ? cart.items : []).forEach((item) => {
      const value = item?.properties?.[eligibleProperty];
      if (String(value || '').toLowerCase() !== eligibleValue) return;
      if (item.product_id != null) productIds.add(String(item.product_id));
    });

    return productIds.size;
  };

  const nativeCodeForCount = (uniqueCount) => {
    const percentage = tiers.reduce((current, tier) => (
      uniqueCount >= tier.min ? tier.percentage : current
    ), 0);
    return percentage > 0 ? String(codesByPercentage[String(percentage)] || '') : '';
  };

  const existingCodesToKeep = (cart, hasBundleCode) => {
    const codes = new Set();

    discountApplications(cart).forEach((application) => {
      if (String(application?.type || '').toLowerCase() !== 'discount_code') return;
      const code = String(application?.title || '').trim();
      if (!code || bundleCodes.has(code.toUpperCase())) return;
      if (hasBundleCode && String(application?.target_type || '').toLowerCase() !== 'shipping_line') return;
      codes.add(code);
    });

    return [...codes];
  };

  const fetchCart = async () => {
    const response = await fetch(cartUrl, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error(`Cart ophalen mislukt (${response.status}).`);
    return response.json();
  };

  const replaceDiscountCodes = async (cart, bundleCode) => {
    const codes = existingCodesToKeep(cart, Boolean(bundleCode));
    if (bundleCode) codes.push(bundleCode);

    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    if (!response.ok) throw new Error(`Kortingscode synchroniseren mislukt (${response.status}).`);
    return response.json();
  };

  const setTriggerBusy = (trigger, busy) => {
    if (!trigger) return;
    trigger.toggleAttribute('aria-busy', busy);
    if ('disabled' in trigger) trigger.disabled = busy;
  };

  const checkout = async (trigger = null) => {
    if (checkoutBusy) return false;
    checkoutBusy = true;
    setTriggerBusy(trigger, true);

    try {
      const cart = await fetchCart();
      const uniqueCount = eligibleUniqueCount(cart);
      const bundleCode = nativeCodeForCount(uniqueCount);
      await replaceDiscountCodes(cart, bundleCode);

      if (bundleCode) {
        const discountUrl = `${normalizedRouteRoot}discount/${encodeURIComponent(bundleCode)}?redirect=${encodeURIComponent(checkoutUrl)}`;
        window.location.assign(discountUrl);
      } else {
        window.location.assign(checkoutUrl);
      }
      return true;
    } catch (error) {
      console.error('[Alfa noodpakket discount] Veilig afrekenen mislukt.', error);
      window.alert('Afrekenen kon de bundelkorting niet veilig controleren. Probeer het opnieuw.');
      checkoutBusy = false;
      setTriggerBusy(trigger, false);
      return false;
    }
  };

  window.AlfaNoodpakketDiscountCheckout = Object.freeze({ checkout });

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || String(submitter.name || '').toLowerCase() !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(submitter);
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.endsWith('/checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(link);
  }, true);
})();
